module.exports = __webpack_public_path__ + "img/caret.3f538ecc.svg";